import React from 'react';
import { AgGridReact } from "ag-grid-react";

export const Asset = () => {
    const columnDefs = [
        { headerName: 'Asset Class', field: 'asset' },
        { headerName: 'MTD%', field: 'mtd', editable: false,cellStyle: { textAlign: "right" },headerClass: "text-end",},
        { headerName: 'QTD%', field: 'qtd', editable: false,cellStyle: { textAlign: "right" },headerClass: "text-end" },
        { headerName: 'YTD%', field: 'ytd', editable: false,cellStyle: { textAlign: "right" },headerClass: "text-end" }
    ];

    const rowData = [
        { asset: "Equities", mtd: 1.89, qtd: 4.56, ytd: 12.34 },
        { asset: "Fixed Income", mtd: 0.78, qtd: 1.34, ytd: 3.56 },
        { asset: "Commodities", mtd: -0.34, qtd: 2.45, ytd: 6.78 },
        { asset: "Real Estate", mtd: 1.12, qtd: 3.45, ytd: 9.23 },
        { asset: "Hedge Funds", mtd: 0.56, qtd: 1.78, ytd: 4.56 }
    ];

    const defaultColDef = {
        flex: 1,
        minWidth: 150,
        wrapHeaderText: true,
        autoHeaderHeight: true,
        editable: true,
        resizable:true
    };

    return (
        <div className="container mt-5">
            <h5 style={{ color: '#037196' }}>Asset Class Performance</h5>
            <div
                className="ag-theme-alpine"
                style={{ height: "50vh", width: "100%" }}
            >
                <AgGridReact
                    rowData={rowData}
                    columnDefs={columnDefs}
                    defaultColDef={defaultColDef}
                />
            </div>
        </div>
    );
};